import { useEffect, useState } from "react";

// Generic data-fetching hook shared by every Analytics chart/KPI component, so each one
// doesn't reimplement its own useEffect + useState fetch logic.
// apiFn: one of the getCrm* functions from src/api/index.js
// params: array of primitive args passed to apiFn, in order (also used as the effect's deps)
export function useAnalyticsFetch(apiFn, params, enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    apiFn(...params)
      .then((result) => {
        if (!cancelled) {
          setData(result && result.data !== undefined ? result.data : null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...params]);

  return { data, loading, error };
}
